import { ref } from 'vue'
import mapboxgl from 'mapbox-gl'
import type { FeatureCollection } from 'geojson'
import { buildBoundsFromCollections, fitMapToBounds } from '../layers/jobTripLayers'

type MaybeCollection = FeatureCollection | null | undefined

export const useMapFitBounds = () => {
  const lastFittedBoundsKey = ref<string | null>(null)

  const fitIfChanged = (
    collections: MaybeCollection[],
    map: mapboxgl.Map | undefined,
    mini: boolean | undefined,
  ): boolean => {
    const bounds = buildBoundsFromCollections(collections)
    if (!bounds) return false

    const boundsKey = `${mini ? 'mini' : 'full'}:${bounds
      .toArray()
      .flat()
      .map((c) => c.toFixed(6))
      .join(':')}`

    if (boundsKey === lastFittedBoundsKey.value) return false

    if (fitMapToBounds(map, mini, bounds)) {
      lastFittedBoundsKey.value = boundsKey
      return true
    }
    return false
  }

  const resetFitKey = () => {
    lastFittedBoundsKey.value = null
  }

  return { fitIfChanged, resetFitKey }
}
